<template>
    <v-sheet>
        <v-card-title class="justify-center"> 발급된 가상계좌가 없습니다. </v-card-title>
        <v-card-actions class="justify-center pt-0">
            <v-btn large color="primary" class="px-6" @click="$emit('post')">가상계좌 발급받기</v-btn>
        </v-card-actions>
    </v-sheet>
</template>

<script>
export default {};
</script>

<style></style>
